import { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  documentPage: {
    boxShadow: theme.shadows[6],
  },
  document: {
    marginTop: 48,
    marginBottom: 48,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

type Props = {
  file: File | string | undefined;
};

const fileAsString = (file: File | string | undefined) => {
  if (!file) return '';

  if (typeof file === 'string') return file;

  return URL.createObjectURL(new Blob([file]));
};

const PngViewer: FC<Props> = ({ file }) => {
  const classes = useStyles();

  const imageFile = fileAsString(file);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.document}>
          <img src={imageFile} alt="PNG" />
        </div>
      </div>
    </>
  );
};

export default PngViewer;
